/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  AppPermissionsEnum,
  ChangePasswordInput,
  ConfirmEmailRequestDto,
  CurrentUserProfileDto,
  LoginResultDto,
  LoginViewModel,
  PtwSessionDto,
  ResetPasswordRequestDto,
  ResultDtoOfBoolean,
  ValidateTokenRequestDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    AppPermissionsEnumFromJSON,
    AppPermissionsEnumToJSON,
    ChangePasswordInputFromJSON,
    ChangePasswordInputToJSON,
    ConfirmEmailRequestDtoFromJSON,
    ConfirmEmailRequestDtoToJSON,
    CurrentUserProfileDtoFromJSON,
    CurrentUserProfileDtoToJSON,
    LoginResultDtoFromJSON,
    LoginResultDtoToJSON,
    LoginViewModelFromJSON,
    LoginViewModelToJSON,
    PtwSessionDtoFromJSON,
    PtwSessionDtoToJSON,
    ResetPasswordRequestDtoFromJSON,
    ResetPasswordRequestDtoToJSON,
    ResultDtoOfBooleanFromJSON,
    ResultDtoOfBooleanToJSON,
    ValidateTokenRequestDtoFromJSON,
    ValidateTokenRequestDtoToJSON,
} from '../models/index';

export interface ChangePasswordRequest {
    changePasswordInput?: ChangePasswordInput;
}

export interface ConfirmActivationRequest {
    confirmEmailRequestDto?: ConfirmEmailRequestDto;
}

export interface LoginRequest {
    returnUrl?: string;
    returnUrlHash?: string;
    ss?: string;
    loginViewModel?: LoginViewModel;
}

export interface ResetPasswordRequest {
    resetPasswordRequestDto?: ResetPasswordRequestDto;
}

export interface SendResetPasswordLinkRequest {
    email: string;
}

export interface UpdateCurrentUserProfileRequest {
    currentUserProfileDto?: CurrentUserProfileDto;
}

export interface ValidateActivateUserTokenRequest {
    validateTokenRequestDto?: ValidateTokenRequestDto;
}

export interface ValidateResetPasswordTokenRequest {
    validateTokenRequestDto?: ValidateTokenRequestDto;
}

/**
 * 
 */
export class AccountApi extends runtime.BaseAPI {

    /**
     */
    async acceptEulaRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/account/accept-eula`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async acceptEula(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.acceptEulaRaw(initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Changes the password of user of current session
     */
    async changePasswordRaw(requestParameters: ChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/account/change-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordInputToJSON(requestParameters.changePasswordInput),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Changes the password of user of current session
     */
    async changePassword(requestParameters: ChangePasswordRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.changePasswordRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * confirms the activation of user
     */
    async confirmActivationRaw(requestParameters: ConfirmActivationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/account/confirm-activation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmEmailRequestDtoToJSON(requestParameters.confirmEmailRequestDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * confirms the activation of user
     */
    async confirmActivation(requestParameters: ConfirmActivationRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.confirmActivationRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Returns the profile of user of current session
     */
    async getCurrentUserProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CurrentUserProfileDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/account/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => CurrentUserProfileDtoFromJSON(jsonValue));
    }

    /**
     * Returns the profile of user of current session
     */
    async getCurrentUserProfile(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getCurrentUserProfileRaw(initOverrides);
        return this.configuration.handleFunction<CurrentUserProfileDto>(response, errorHandlers);
    }

    /**
     * Returns session-information of user of current session
     */
    async getSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PtwSessionDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/account/session`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => PtwSessionDtoFromJSON(jsonValue));
    }

    /**
     * Returns session-information of user of current session
     */
    async getSession(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getSessionRaw(initOverrides);
        return this.configuration.handleFunction<PtwSessionDto>(response, errorHandlers);
    }

    /**
     * Returns the permissions of user of current session
     */
    async getUsersPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppPermissionsEnum>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/account/permissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppPermissionsEnumFromJSON));
    }

    /**
     * Returns the permissions of user of current session
     */
    async getUsersPermissions(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getUsersPermissionsRaw(initOverrides);
        return this.configuration.handleFunction<Array<AppPermissionsEnum>>(response, errorHandlers);
    }

    /**
     * Create a new session
     */
    async loginRaw(requestParameters: LoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResultDto>> {
        const queryParameters: any = {};

        if (requestParameters.returnUrl !== undefined) {
            queryParameters['returnUrl'] = requestParameters.returnUrl;
        }

        if (requestParameters.returnUrlHash !== undefined) {
            queryParameters['returnUrlHash'] = requestParameters.returnUrlHash;
        }

        if (requestParameters.ss !== undefined) {
            queryParameters['ss'] = requestParameters.ss;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/account/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginViewModelToJSON(requestParameters.loginViewModel),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResultDtoFromJSON(jsonValue));
    }

    /**
     * Create a new session
     */
    async login(requestParameters: LoginRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.loginRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<LoginResultDto>(response, errorHandlers);
    }

    /**
     * Log out the current session Microsoft.AspNetCore.Mvc.IgnoreAntiforgeryTokenAttribute is SET here intentionally! as disabling user leads to sign out of Session.User in Backend and return a 401 which leads the frontend to call /api/account/logout with an invalid anti-forgery token
     */
    async logoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/account/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Log out the current session Microsoft.AspNetCore.Mvc.IgnoreAntiforgeryTokenAttribute is SET here intentionally! as disabling user leads to sign out of Session.User in Backend and return a 401 which leads the frontend to call /api/account/logout with an invalid anti-forgery token
     */
    async logout(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.logoutRaw(initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Resets the password
     */
    async resetPasswordRaw(requestParameters: ResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultDtoOfBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/account/reset-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordRequestDtoToJSON(requestParameters.resetPasswordRequestDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoOfBooleanFromJSON(jsonValue));
    }

    /**
     * Resets the password
     */
    async resetPassword(requestParameters: ResetPasswordRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.resetPasswordRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ResultDtoOfBoolean>(response, errorHandlers);
    }

    /**
     * Sends a reset password link to email
     */
    async sendResetPasswordLinkRaw(requestParameters: SendResetPasswordLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.email === null || requestParameters.email === undefined) {
            throw new runtime.RequiredError('email','Required parameter requestParameters.email was null or undefined when calling sendResetPasswordLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/account/reset-password/{email}`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters.email))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sends a reset password link to email
     */
    async sendResetPasswordLink(requestParameters: SendResetPasswordLinkRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.sendResetPasswordLinkRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Updates the profile of user of current session
     */
    async updateCurrentUserProfileRaw(requestParameters: UpdateCurrentUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CurrentUserProfileDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/account/profile`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CurrentUserProfileDtoToJSON(requestParameters.currentUserProfileDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => CurrentUserProfileDtoFromJSON(jsonValue));
    }

    /**
     * Updates the profile of user of current session
     */
    async updateCurrentUserProfile(requestParameters: UpdateCurrentUserProfileRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateCurrentUserProfileRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<CurrentUserProfileDto>(response, errorHandlers);
    }

    /**
     * Validates the confirm email token
     */
    async validateActivateUserTokenRaw(requestParameters: ValidateActivateUserTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultDtoOfBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/account/activate-user/validate-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateTokenRequestDtoToJSON(requestParameters.validateTokenRequestDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoOfBooleanFromJSON(jsonValue));
    }

    /**
     * Validates the confirm email token
     */
    async validateActivateUserToken(requestParameters: ValidateActivateUserTokenRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateActivateUserTokenRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ResultDtoOfBoolean>(response, errorHandlers);
    }

    /**
     * Validates the reset password token
     */
    async validateResetPasswordTokenRaw(requestParameters: ValidateResetPasswordTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultDtoOfBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/account/reset-password/validate-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateTokenRequestDtoToJSON(requestParameters.validateTokenRequestDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoOfBooleanFromJSON(jsonValue));
    }

    /**
     * Validates the reset password token
     */
    async validateResetPasswordToken(requestParameters: ValidateResetPasswordTokenRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateResetPasswordTokenRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ResultDtoOfBoolean>(response, errorHandlers);
    }

}
